import React from "react";
// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import TextField from "@material-ui/core/TextField";
import AddAlert from "@material-ui/icons/AddAlert";
import Snackbar from "../../components/Snackbar/Snackbar";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import fetchAPI from "../../util/swt/fetchAPI";
import {METHOD} from "../../util/enum/method";
import {endpoints} from "../../util/swt/endpoints";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles(styles);

export default function ForgotPasswordPage() {
  const classes = useStyles();
  const history = useHistory();
  const [email, setEmail] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [alertSuccess, setAlertSuccess] = React.useState(false);
  const [alertError, setAlertError] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const handleSubmit = async (ev) => {
    ev && ev.preventDefault();
    if (!email || email.trim() === "") {
      setMessage('Debe ingresar un correo válido.');
      setAlertError(true);
      setTimeout(() => setAlertError(false), 4000);
      return;
    }
    try {
      setLoading(true);
      await fetchAPI(endpoints.forgotPassword, METHOD.POST, { email: email.trim() });
      setLoading(false);
      setMessage('Se ha enviado un correo con instrucciones si la cuenta existe.');
      setAlertSuccess(true);
      setTimeout(() => {
        setAlertSuccess(false);
        history.push('/login');
      }, 3500);
    } catch (err) {
      setLoading(false);
      setMessage(err.message || 'Error enviando solicitud.');
      setAlertError(true);
      setTimeout(() => setAlertError(false), 4000);
    }
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <Snackbar
          place="tr"
          color="success"
          icon={AddAlert}
          message={message}
          open={alertSuccess}
          closeNotification={() => setAlertSuccess(false)}
          close
        />
        <Snackbar
          place="tr"
          color="danger"
          icon={AddAlert}
          message={message}
          open={alertError}
          closeNotification={() => setAlertError(false)}
          close
        />

        <GridItem xs={12} sm={8} md={4}>
          <form onSubmit={handleSubmit}>
            <Card
              className={classes.cardHidden}
              style={{
                borderRadius: "20px",
                boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                backdropFilter: "blur(12px)",
                overflow: "hidden",
              }}
            >
              <CardHeader
                className={`${classes.cardHeader} ${classes.textCenter}`}
                style={{
                  background: "linear-gradient(135deg, #0BA360 0%, #3FD1A7 100%)",
                  color: "#fff",
                  padding: "25px",
                }}
              >
                <h4 className={classes.cardTitle} style={{ fontWeight: "600" }}>
                  Recuperar Contraseña
                </h4>
              </CardHeader>

              <CardBody style={{ padding: "30px 25px" }}>
                <div style={{ marginBottom: 12 }}>
                  <div style={{ marginBottom: 8, color: '#444' }}>Ingresa el correo electrónico asociado a tu cuenta</div>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Correo Electrónico"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </CardBody>

              <CardFooter className={classes.justifyContentCenter} style={{ padding: "20px" }}>
                <Button
                  color="info"
                  size="lg"
                  block
                  type="submit"
                  disabled={loading}
                  style={{
                    background: "linear-gradient(90deg, #0BA360 0%, #3FD1A7 100%)",
                    borderRadius: "10px",
                    fontWeight: "bold",
                    padding: "12px",
                    color: "#fff",
                    fontSize: "16px",
                  }}
                >
                  {loading ? 'Enviando...' : 'Enviar correo'}
                </Button>
                <div style={{ marginTop: 12, textAlign: 'center' }}>
                  <Button
                    color="transparent"
                    size="sm"
                    onClick={() => history.push('/login')}
                    style={{ textTransform: 'none', color: '#0BA360', fontWeight: 600 }}
                  >
                    Volver al Login
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}

